import { render } from "./FavIcon.vue?vue&type=template&id=1d5242ec"
import script from "./FavIcon.vue?vue&type=script&lang=js"
export * from "./FavIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/etos-b2b/b2b-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__